export default __webpack_public_path__ + "static/media/Schema_Programmatics-adapted.9c19c410.png";